import React, { useCallback } from "react";
import Avatar from "../Avatar";
import GameCountAndPeriod from "../GameCountAndPeriod";
import { DecisionTable } from "./DecisionTable";
import { useEffect, useRef, useState } from "react";
import Spinner from "../Spinner";
import Result from "./Result";
import { getGameData, saveGameData } from '../../services/service';
import { CheckSvg } from "../ui/CheckSvg";

const Decision = () => {

	const [loading, setLoading] = useState(false);
	const [resultData, setResultData] = useState(null);
	const [decisionData, setDecisionData] = useState(null);
	const [message, setMessage] = useState('');
	const [tables, setTables] = useState([]);
	const [formularId, setFormularId] = useState(null);
	const [isSaving, setIsSaving] = useState(false);
	const [showCheck, setShowCheck] = useState(false);

	const formRef = useRef(null);

	const updateData = useCallback(() => {
		setLoading(true);
		getGameData().then(data => {
			console.log('before if else')
			console.log(data)
			const status = data.status;
			if (status === 'fail' || status === 'start' || status === 'success' || status === 'norestart') {
				console.log('new result data:')
				console.log(data)
				setResultData(data);
			} else {
				console.log('new decision data:')
				console.log(data);
				setDecisionData(data);
				setTables(data.formulare.GUI.FORMULAR.TABELLEVIEW);
				setFormularId(data.formulare.GUI.FORMULAR["@attributes"].id);
				setMessage('Bevor du deine Entscheidungen eingibst, schau dir die Berichte der Vorperiode sowie die wichtigen Daten für die aktuelle Periode an.');

			}
			setLoading(false);
		}).catch(e => console.log(e))
	}, [])

	useEffect(() => {
		console.log('render')
		updateData();
	}, [updateData])

	useEffect(() => {
		if (loading || !decisionData?.formulare) {
			setMessage("Sobald die Berechnung abgeschlossen ist, findet ihr den aktuellen Bericht und das Szenario im Bereich über den Entscheidungen. Diese sind die Entscheidungsgrundlage für die folgende Periode und sollten gründlich analysiert werden!");

		}
	}, [loading, decisionData])

	if (resultData) {
		console.log('rendering Result with following data:')
		console.log(resultData)
		return <Result initialData={resultData} />;
	}

	if (loading || !decisionData?.formulare) {
		return (
			<>
				<Avatar message={message} />
				<Spinner />
			</>
		);
	}

	const handleSubmit = (e, action, saveOrCalculate) => {
		e.preventDefault();

		const formData = new FormData(formRef.current);

		formData.append(Object.keys(action)[0], Object.values(action)[0]);
		formData.append('tx_stzplanspieloffice_decision[formperiod]', decisionData.gameStatus.aktp);
		formData.append('tx_stzplanspieloffice_decision[user_id]', decisionData.user_id);
		formData.append('tx_stzplanspieloffice_decision[team_id]', decisionData.team_id);

		console.log('sending data...')
		formData.forEach((value, key) => {
			console.log(`${key}: ${value}`);
		});

		saveGameData(formData).then((data) => {
			console.log(data)
			if (saveOrCalculate === 1) {
				updateData();
				console.log('SAVE AND CALCULATE!!')
			} else {
				console.log('SAVE ONLY!!')
				setTimeout(() => {
					setShowCheck(true);
					setTimeout(() => {
						setIsSaving(false);
						setShowCheck(false);
					}, 1000);
				}, 300)
				
			}
			// setResultData(null);
			// updateData();
		}).catch(e => console.log(e))
	};

	return (
		<div>

			<Avatar message={message} />

			<form
				className="clipboard-form"
				ref={formRef}
			>
				<div className="clipboard-clip"></div>
				<GameCountAndPeriod data={decisionData.gameStatus} />

				{tables
					.filter((table) => table["@attributes"].visibility === "0")
					.map((table) => (
						<DecisionTable
							key={table["@attributes"].id}
							formularId={formularId}
							table={table}
						/>
					))
				}

				<div className="button-container">
					<div className="spinner-container">
						{isSaving
							?
							showCheck ? <CheckSvg /> : <Spinner />
							:
							<input
								className="button_orange"
								type="button"
								value="Speichern"
								name="tx_stzplanspieloffice_decision[Save_Decision]"
								onClick={(e) => {
									handleSubmit(e, { [e.target.name]: 'save' }, 0);
									setIsSaving(true);
								}}
							/>
						}
					</div>

					<input
						className="button_orange"
						type="button"
						value="Speichern und berechnen"
						name="tx_stzplanspieloffice_decision[Calc_Decision]"
						onClick={(e) => {
							handleSubmit(e, { [e.target.name]: 'saveAndCalculate' }, 1);
						}}
					/>
				</div>
			</form>
		</div>
	);
};

export default Decision;
